"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const dayjs_1 = __importDefault(require("dayjs"));
const plugin_1 = require("@/plugin");
const HomeAnalysisDashboard_vue_1 = __importDefault(require("./module/HomeAnalysisDashboard.vue"));
const HomeAnalysisContract_vue_1 = __importDefault(require("./module/HomeAnalysisContract.vue"));
const HomeAnalysisTable_vue_1 = __importDefault(require("./module/HomeAnalysisTable.vue"));
const HomeFlow_vue_1 = __importDefault(require("./module/HomeFlow.vue"));
const analysis_1 = __importDefault(require("../../api/analysis"));
const overdue_1 = require("../../select/overdue");
const router_1 = __importDefault(require("../../router"));
exports.default = (0, vue_1.defineComponent)({
    name: 'HomeView',
    components: {
        HomeAnalysisDashboard: HomeAnalysisDashboard_vue_1.default,
        HomeAnalysisContract: HomeAnalysisContract_vue_1.default,
        HomeAnalysisTable: HomeAnalysisTable_vue_1.default,
        HomeFlow: HomeFlow_vue_1.default
    },
    data() {
        const date = (0, dayjs_1.default)();
        const currentMonth = date.format('YYYY-MM');
        const lastMonth = date.subtract(1, 'month').format('YYYY-MM');
        const last2Month = date.subtract(2, 'month').format('YYYY-MM');
        return {
            list: [
                {
                    name: '重点经销商',
                    api: analysis_1.default.homeDealerList,
                    columns: [
                        {
                            dataIndex: 'orgname',
                            title: '经销商名称',
                        },
                        {
                            dataIndex: 'qty_over3',
                            title: last2Month,
                            customRender({ text }) {
                                return Number(text);
                            }
                        },
                        {
                            dataIndex: 'qty_over2',
                            title: lastMonth,
                            customRender({ text }) {
                                return Number(text);
                            }
                        },
                        {
                            dataIndex: 'qty_over1',
                            title: currentMonth,
                            customRender({ text }) {
                                return Number(text);
                            }
                        },
                    ]
                },
                {
                    name: '催收回款排行',
                    api: analysis_1.default.homeCollectionCountList,
                    columns: [
                        {
                            dataIndex: 'userName',
                            title: '催收人员',
                        },
                        {
                            dataIndex: 'position',
                            title: '岗位',
                        },
                        {
                            dataIndex: 'm0',
                            title: 'M0',
                        },
                        {
                            dataIndex: 'm1',
                            title: 'M1',
                        },
                        {
                            dataIndex: 'm2',
                            title: 'M2',
                        },
                        {
                            dataIndex: 'm3',
                            title: 'M3+',
                        },
                        {
                            dataIndex: 'totalAmount',
                            title: '催收回款',
                        },
                    ]
                },
                {
                    name: '车辆收回排行',
                    api: analysis_1.default.homeKeepCountList,
                    columns: [
                        {
                            dataIndex: 'applyUserName',
                            title: '催收人员',
                        },
                        {
                            dataIndex: 'assignType',
                            title: '类型',
                            customRender({ text }) {
                                return overdue_1.overdueCollectType.getItem(text).label;
                            }
                        },
                        {
                            dataIndex: 'overM0',
                            title: 'M0',
                        },
                        {
                            dataIndex: 'overM1',
                            title: 'M1',
                        },
                        {
                            dataIndex: 'overM2',
                            title: 'M2',
                        },
                        {
                            dataIndex: 'overM3',
                            title: 'M3+',
                        },
                        {
                            dataIndex: 'overSum',
                            title: '合计台数',
                        },
                    ]
                },
                {
                    name: '车辆处置排行',
                    api: analysis_1.default.homeHandleCountList,
                    columns: [
                        {
                            dataIndex: 'applyUserName',
                            title: '催收人员',
                        },
                        {
                            dataIndex: 'assignType',
                            title: '类型',
                            customRender({ text }) {
                                return overdue_1.overdueCollectType.getItem(text).label;
                            }
                        },
                        {
                            dataIndex: 'shzcCount',
                            title: '赎回转正常',
                        },
                        {
                            dataIndex: 'shjqCount',
                            title: '赎回结清',
                        },
                        {
                            dataIndex: 'handleCount',
                            title: '处置台数',
                        },
                        {
                            dataIndex: 'handleAmountSum',
                            title: '处置金额',
                        },
                    ]
                },
            ],
            todo: {
                name: '催收待办',
                api: analysis_1.default.homeTodo,
                params: {
                    pageNo: 1,
                    pageSize: 10,
                },
                columns: [
                    {
                        dataIndex: 'contractNumber',
                        title: '合同号',
                        customCell(record) {
                            return {
                                class: 'local-main-link',
                                onClick() {
                                    router_1.default.push(`/overdue/info/${record.id}`);
                                }
                            };
                        },
                    },
                    {
                        dataIndex: 'customerName',
                        title: '承租人',
                    },
                    {
                        dataIndex: 'orgname',
                        title: '经销商',
                    },
                    {
                        dataIndex: 'areaName',
                        title: '所属区域',
                    },
                    {
                        dataIndex: 'cleanLeaseMoney',
                        title: '融资总额',
                    },
                    {
                        dataIndex: 'incomeNumber',
                        title: '融资期数',
                    },
                    {
                        dataIndex: 'minPlanList',
                        title: '已还期数',
                        customRender({ text }) {
                            return text ? text - 1 : '';
                        },
                    },
                    {
                        dataIndex: 'maxDay',
                        title: '逾期天数',
                    },
                    {
                        dataIndex: 'rentOver',
                        title: '逾期租金',
                    },
                    {
                        dataIndex: 'residueRent',
                        title: '剩余租金',
                    },
                    {
                        dataIndex: 'overdueRank',
                        title: '逾期级别',
                        customRender({ text }) {
                            return overdue_1.overdueLevel.getItem(text).label;
                        },
                    },
                    {
                        dataIndex: 'newFlag',
                        title: '来源',
                        customRender({ text }) {
                            // eslint-disable-next-line eqeqeq
                            return text == '1' ? '新入' : '回签';
                        },
                    },
                    {
                        dataIndex: 'assignType',
                        title: '类型',
                        customRender({ text }) {
                            return overdue_1.overdueCollectType.getItem(text).label;
                        }
                    },
                    {
                        dataIndex: 'assignTime',
                        title: '分派时间',
                    },
                ]
            }
        };
    },
    computed: {
        areaWidth() {
            const line = 2;
            return (this.width - (line - 1) * 16) / line;
        },
        width() {
            return plugin_1.reactiveLayout.data.main.width - 16 * 2;
        }
    }
});
